import React, { Component } from 'react';
import { string, object, func } from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import { getTutorHandbookUrl } from '@dragonfruit/redux/tutorAudit';

import styles from './AccountTestsCard.scss';

const mapStateToProps = state => ({
  userInfo: state.profile.data,
  handbookUrl: getTutorHandbookUrl(state),
});

class AccountTestsCard extends Component {
  static propTypes = {
    handbookUrl: string.isRequired,
    t: func.isRequired,
    userInfo: object,
  };

  static defaultProps = {
    userInfo: {},
  };

  state = {};

  render() {
    const { t, handbookUrl } = this.props;

    return (
      <div className={styles.input}>
        <div className={styles.fieldContainer}>
          <div className={styles.reset}>
            <p className={styles.value}>{t('account.handbookTitle')}</p>
            <a
              className={styles.linkButton}
              href={handbookUrl}
              target="_blank"
              rel="noreferrer"
            >
              <h6>{t('account.viewCta')}</h6>
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default translate(['account'])(
  connect(mapStateToProps, {})(AccountTestsCard)
);



// WEBPACK FOOTER //
// ./app/containers/Account/children/AccountProfile/components/AccountTestsCard/AccountTestsCard.jsx